
type DelayedIntervalHandle = {
	timeout?: SetTimeoutHandle;
	interval?: number;
};

function setDelayedInterval(
	callback: Function,
	intervalInMs: number,
	delayInMs: number
): DelayedIntervalHandle {
	const result: DelayedIntervalHandle = {};

	if (delayInMs > 0) {
		result.timeout = setTimeout(
			() => {
				result.timeout = undefined;
				result.interval = setInterval(callback, intervalInMs);
				callback();
			},
			delayInMs
		);
	} else {
		result.interval = setInterval(callback, intervalInMs);
	}

	return result;
}

function clearDelayedInterval(handle: DelayedIntervalHandle) {
	if (!handle) {
		return;
	}

	const { timeout, interval } = handle;

	if (timeout) {
		clearTimeout(timeout);
	}

	if (interval) {
		clearInterval(interval);
	}
}

export {
	setDelayedInterval,
	clearDelayedInterval,
	type DelayedIntervalHandle
};
